import { Navigate } from "react-router-dom";

export default function ErrorPage() {
  return (
    <Navigate
      to="/"
      replace
    ></Navigate>
  );
}